<template>
  <div class="home" style="margin-bottom:51px !important;
    overflow: scroll;    margin-top: -1px;">
  
    <search></search>
  </div>
  
  
</template>

<script>
// @ is an alias to /src
// import offr from '@/components/Items'
import search from '@/components/Searchitem'

  import axios from 'axios';

export default {
   components: {      
        // offr,
        search
        
        
       },
        data: () => ({
            name: 'Search Item',
            products : []
        }),
        mounted() {
         
            this.$parent.$children[0].$parent.ttlval = this.name

            

       },
    methods: {
   
     
  },

 
}
</script>
